import ActionTypes from '../constants';

const initialState = {
    customerTypes: {},
    customerType: {}
    // loading: false,
};

const customerTypeReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETCUSTOMERTYPESUCCESS:
            return {
                ...state,
                customerTypes: action.payload,
            }
        case ActionTypes.GETCUSTOMERTYPEBYIDSUCCESS:
            return {
                ...state,
                customerType: action.payload,
            }
        default:
            return state;
    }
}

export default customerTypeReducer;